// Copyright (c) 2016 Deere & Company

import MassChannelPdiClaim from '@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-pdi';

export const getUpdatedMassChannelPdiClaim = (currentClaim, selectedAction) =>
    MassChannelPdiClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/services/update-mass-channel-pdi-claim.js